import React, { useState, useEffect } from 'react';
import './BatchConfig.css';

const BatchConfig = ({ onChange, recipientCount }) => {
  const [config, setConfig] = useState({
    batchSize: 50,
    delaySeconds: 30
  });
  
  const [estimatedTime, setEstimatedTime] = useState('');
  
  useEffect(() => {
    onChange(config);
    calculateEstimatedTime();
  }, [config, recipientCount]);
  
  const calculateEstimatedTime = () => {
    if (recipientCount === 0) {
      setEstimatedTime('Selecione destinatários');
      return;
    }
    
    const batches = Math.ceil(recipientCount / config.batchSize);
    const totalSeconds = (batches - 1) * config.delaySeconds;
    
    if (totalSeconds < 60) {
      setEstimatedTime(`${totalSeconds} segundos`);
    } else if (totalSeconds < 3600) {
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      setEstimatedTime(`${minutes} minutos${seconds > 0 ? ` e ${seconds} segundos` : ''}`);
    } else {
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      setEstimatedTime(`${hours} horas${minutes > 0 ? ` e ${minutes} minutos` : ''}`);
    }
  };
  
  const handleConfigChange = (field, value) => {
    const numValue = parseInt(value) || 0;
    if (numValue > 0) {
      setConfig(prev => ({
        ...prev,
        [field]: numValue
      }));
    }
  };
  
  return (
    <div className="batch-config-container">
      <h3>Configuração de Envio em Lote</h3>
      
      <div className="config-info">
        <div className="info-icon">⚙️</div>
        <p>
          Configure os parâmetros de envio para evitar bloqueios e garantir a entrega dos emails.
        </p>
      </div>
      
      <div className="config-grid">
        <div className="config-item">
          <label htmlFor="batch-size">Tamanho do Lote</label>
          <input
            type="number"
            id="batch-size"
            value={config.batchSize}
            onChange={(e) => handleConfigChange('batchSize', e.target.value)}
            min="1"
            max="200"
            className="config-input"
          />
          <span className="config-hint">Emails por lote (recomendado: 50)</span>
        </div>
        
        <div className="config-item">
          <label htmlFor="delay-seconds">Intervalo entre Lotes</label>
          <input
            type="number"
            id="delay-seconds"
            value={config.delaySeconds}
            onChange={(e) => handleConfigChange('delaySeconds', e.target.value)}
            min="10"
            max="300"
            className="config-input"
          />
          <span className="config-hint">Segundos de espera (recomendado: 30)</span>
        </div>
      </div>
      
      <div className="batch-summary">
        <h4>Resumo do Envio</h4>
        <div className="summary-items">
          <div className="summary-item">
            <span className="label">Total de destinatários:</span>
            <span className="value">{recipientCount}</span>
          </div>
          <div className="summary-item">
            <span className="label">Número de lotes:</span>
            <span className="value">
              {recipientCount > 0 ? Math.ceil(recipientCount / config.batchSize) : 0}
            </span>
          </div>
          <div className="summary-item">
            <span className="label">Tempo estimado:</span>
            <span className="value">{estimatedTime}</span>
          </div>
        </div>
      </div>
      
      <div className="config-presets">
        <p>Configurações rápidas:</p>
        <div className="preset-buttons">
          <button 
            type="button"
            className="preset-button"
            onClick={() => setConfig({ batchSize: 25, delaySeconds: 60 })}
          >
            Conservador
            <span>25 emails / 60s</span>
          </button>
          <button 
            type="button"
            className="preset-button recommended"
            onClick={() => setConfig({ batchSize: 50, delaySeconds: 30 })}
          >
            Recomendado
            <span>50 emails / 30s</span>
          </button>
          <button 
            type="button"
            className="preset-button"
            onClick={() => setConfig({ batchSize: 100, delaySeconds: 20 })}
          >
            Rápido
            <span>100 emails / 20s</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BatchConfig;